export const RecruitmentReasonsTypesEnum = {
  replacement: {
    key: "replacement",
    value: "replacement",
  },
  reallocatedPosition: {
    key: "reallocated-position",
    value: "reallocated-position",
  },
  budgetedNewPosition: {
    key: "budgeted-position",
    value: "budgeted-position",
  },
  nonBudgetedNewPosition: {
    key: "non-budgeted-position",
    value: "non-budgeted-position",
  },
  other: {
    key: "other",
    value: "other",
  },
};
